export default __webpack_public_path__ + "static/95-57384990e563581a59712da3c19c2452.gif";